import DqMinimumordercoinrollspanel from './src/minimumordercoinrollspanel'

DqMinimumordercoinrollspanel.install = function (Vue) {
  Vue.component(DqMinimumordercoinrollspanel.name, DqMinimumordercoinrollspanel)
}

export default DqMinimumordercoinrollspanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/minimumordercoinrollspanel/minimumordercoinrollspanel.js